import {
    ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR,
    BannersEditMassActions,
    CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO,
    CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR,
    ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsSiteLinksEditorReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        siteLinksEditorVisible: true
                    }
                }
            };
        case ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR:
        case CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR:
            return bannersEditMassActionsInitialState;
        case CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        currentSiteLinksActiveRadioButton: action.value
                    }
                }
            };
        default:
            return state;
    }
}
